/**
 * @fileoverview PUT handler for the "/companies/:company_id/sender_verification/sending_domains/verify" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationSendingDomainsVerifyCacheKeys } from "./constants";
import type {
  PutCompaniesCompanyIdSenderVerificationSendingDomainsVerifyProps,
  CompaniesCompanyIdSenderVerificationSendingDomainsVerifyResult,
} from "./types";

export const putCompaniesCompanyIdSenderVerificationSendingDomainsVerify = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationSendingDomainsVerifyCacheKeys,
  (
    props: PutCompaniesCompanyIdSenderVerificationSendingDomainsVerifyProps
  ): Promise<CompaniesCompanyIdSenderVerificationSendingDomainsVerifyResult> => {
    return fetch(
      `/companies/${props.companyId}/sender_verification/sending_domains/verify`,
      "PUT",
      {
        domain_name: props.domainName,
      },
      {},
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
